import './nav.scss';
import Sloth from '../Sloth';
import $ from 'jquery';

@Sloth.component({
    defaultOptions : {
        phoneicon : '.Nav-icon' // 手机端点击出菜单的按钮
    }
})

export default class Nav {
    onInit() {
        if (!Sloth.isMobile()) return;

        const obj = this.dom;
        const options = this.options;
        const phoneicon = $(options.phoneicon);

        phoneicon.on('click', () => {
            $('.Nav-container').toggle();
            if(!$('.Nav-container').is(':visible')) $('.Nav-subNav', obj).hide();
        });

        $('.Nav-item_more > a', this.dom).on('click', function (evt) {
            evt.preventDefault();
            $('.Nav-subNav', $(this).parent()).toggle();
        });


        $(document).on('click', (evt) => {
            if($(evt.target).is(phoneicon)) return;
            if($(evt.target).parents('.Nav-container').length !== 0) return;
            $('.Nav-container').hide();
        });
    }
}



/** WEBPACK FOOTER **
 ** ./components/Nav/nav.js
 **/